
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 72 72"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1310"}},[_c('g',{attrs:{"data-name":"Group 1307"}},[_c('g',{attrs:{"data-name":"Group 1309"}},[_c('circle',{staticClass:"outer-circle",attrs:{"data-name":"Ellipse 158","cx":"36","cy":"36","r":"36","fill":"#ffd93e","opacity":".6"}})])]),_c('g',{attrs:{"data-name":"Group 1308","transform":"translate(-6889.722 -1388.499)"}},[_c('path',{attrs:{"data-name":"Path 561","d":"M6949.91 1424.981a29.934 29.934 0 01-48.021 0 29.924 29.924 0 0148.021 0z","fill":"none","stroke":"#6d66a2","stroke-miterlimit":"10","stroke-width":"4"}}),_c('circle',{staticClass:"Ellipse_33",attrs:{"data-name":"Ellipse 33","cx":"7.891","cy":"7.891","r":"7.891","transform":"translate(6918.008 1417.086)","fill":"none","stroke":"#6d66a2","stroke-miterlimit":"10","stroke-width":"4"}})])])])
          )
        }
      }
    